import { Extension } from '@tiptap/core'
import { createInsertionPulsePlugin } from './insertion-pulse-plugin'

export const InsertionPulseExtension = Extension.create({
  name: 'insertionPulse',

  addProseMirrorPlugins() {
    return [createInsertionPulsePlugin()]
  },
})
